// test2343
(2343 && 0);
